var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconDf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3176 0.081543C8.38961 0.081543 5.17432 3.29694 5.17432 7.22495C5.17432 9.62689 6.38122 11.7537 8.21314 13.0477C3.949 14.757 0.922607 18.9272 0.922607 23.7923C0.929131 24.0863 1.05052 24.3661 1.26079 24.5718C1.47106 24.7774 1.75349 24.8927 2.04761 24.8927C2.34173 24.8927 2.62416 24.7774 2.83442 24.5718C3.04469 24.3661 3.16608 24.0863 3.17261 23.7923C3.17261 18.6285 7.33618 14.4671 12.5 14.4671C17.6638 14.4671 21.8252 18.6285 21.8252 23.7923C21.8252 24.091 21.9438 24.3773 22.155 24.5885C22.3662 24.7997 22.6526 24.9183 22.9513 24.9183C23.25 24.9183 23.5364 24.7997 23.7476 24.5885C23.9587 24.3773 24.0774 24.091 24.0774 23.7923C24.0774 18.8351 20.933 14.6034 16.5408 12.9576C18.3012 11.6562 19.4499 9.57289 19.4499 7.22495C19.4499 3.29694 16.2457 0.081543 12.3176 0.081543ZM12.3176 2.33378C15.0297 2.33378 17.2 4.51292 17.2 7.22495C17.2 9.93698 15.0297 12.1072 12.3176 12.1072C9.6056 12.1072 7.42651 9.93698 7.42651 7.22495C7.42651 4.51292 9.6056 2.33378 12.3176 2.33378Z",
    fill: "#9EA0A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconDf);
export default __webpack_public_path__ + "static/media/user-icon-df.3da3b6b7a1f8faf1bada5f1bf2894a9d.svg";
export { ForwardRef as ReactComponent };